<template>
  <div
    class="l-report"
    :class="{ 'is-visible': visible }"
    onselectstart="return false;"
    oncontextmenu="return false;"
  >
    <div class="l-report__mask" @click.self="onClose"></div>

    <div class="l-report__stage">
      <div class="l-report__light" aria-hidden="true"></div>

      <div class="l-report__panel" role="dialog" aria-modal="true">
        <div class="l-report__badge-wrap">
          <img class="l-report__badge" src="./images/mental.png" alt="恭喜通关" />
          <div class="l-report__stars" aria-label="通关星级">
            <span
              v-for="i in 5"
              :key="i"
              class="l-report__star"
              :class="{ 'is-active': displayStar >= i }"
              aria-hidden="true"
            ></span>
          </div>

          <div class="l-report__level-pill">
            {{ displayLevelText }}
          </div>
        </div>

        <div
          class="l-report__table"
          role="table"
          aria-label="通关结果"
          :style="{ '--column-count': storyNames.length }"
        >
          <div class="l-report__content">
            <div class="l-report__titles" role="rowgroup">
              <div class="l-report__title-cell" aria-hidden="true"></div>
              <div
                v-for="(title, index) in storyNames"
                :key="index"
                class="l-report__title-cell"
                role="columnheader"
              >
                <div class="l-report__title-line">{{ title }}</div>
              </div>
              <div class="l-report__title-cell" aria-hidden="true"></div>
            </div>

            <div v-for="row in displayRows" :key="row.key" class="l-report__row" role="row">
              <div class="l-report__cell l-report__cell--name" role="cell">{{ row.name }}</div>
              <div
                v-for="(val, index) in row.values"
                :key="index"
                class="l-report__cell l-report__cell--value"
                role="cell"
              >
                {{ val }}
              </div>
              <div class="l-report__cell l-report__cell--coin" role="cell">
                <span class="l-report__coin-icon" aria-hidden="true"></span>
                <span class="l-report__coin-text">{{ row.coin }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="l-report__actions">
          <button type="button" class="l-report__btn is-yellow" @click="onClose">关闭</button>
          <button type="button" class="l-report__btn is-green" @click="onRank">战队排名</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import canvasConfetti from 'canvas-confetti'
import { TEST_ELEMENT, LessonTitleMap } from '@/constants/enum'

export default {
  name: 'l-report',
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lastX: 0,
    }
  },
  computed: {
    displayStar() {
      const n = Number(this.options && this.options.star)
      if (Number.isFinite(n)) return Math.max(0, Math.min(5, Math.floor(n)))
      return 3
    },
    displayLevelText() {
      const options = this.options
      if (!options) return ''
      // 拼接 parentName + name 作为关卡信息
      const parentName = options.parentName || ''
      const name = options.name || ''
      if (parentName && name) {
        return `${parentName}-${name}`
      }
      return parentName || name
    },
    storyNames() {
      const names = this.options && this.options.storyNames
      return names || []
    },
    displayElements() {
      const options = this.options || {}
      const elements = Object.entries(options.elements || {}).map(([key, value]) => {
        // 特殊处理心法+，虽然 type 可能也是 802, 但要显示为音频，后面可能会单独开发 心法+ 元素
        if (key === '心法+') {
          return { ...value, name: '音频' }
        }
        return { ...value, name: LessonTitleMap[value.type] || key }
      })
      return elements.filter((element) => element.word || TEST_ELEMENT.includes(element.type))
    },
    displayRows() {
      const rows = []
      this.displayElements.forEach((element) => {
        const datas = element.datas || []
        // 动态生成每列的数据
        const values = datas.map((item) => {
          if (item.word)
            return item.word
          else if (item.right)
            return `${item.right || 0}/${item.total || 0}`
          else
            return '-'
        })
        rows.push({
          key: element.name,
          name: element.name,
          values: values,
          coin: element.coin ? `+${element.coin}` : '+0',
        })
      })
      return rows
    },
  },
  methods: {
    onClose() {
      // 兼容旧的外部注入关闭函数，同时提供事件回调
      if (typeof this.closed === 'function') this.closed()
      this.$emit('close')
    },
    onRank() {
      window.location.href = `/rank?id=${this.options.topId}&lessonId=${this.options.id}&sort=${this.options.rankType}`
    },
    confetti(hard) {
      let _ = this
      let clientX = 0.5 * window.innerWidth
      const direction = Math.sign(_.lastX - clientX)
      _.lastX = clientX
      const particleCount = hard ? _.r(122, 245) : _.r(2, 15)
      canvasConfetti({
        particleCount,
        angle: _.r(90, 90 + direction * 10),
        spread: window.innerWidth,
        origin: {
          x: 0.5,
          y: 0.5,
        },
      })
    },
    r(mi, ma) {
      return parseInt(Math.random() * (ma - mi) + mi)
    },
  },
}
</script>

<style scoped>
.l-report {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  transition: opacity 180ms ease;
}

.l-report.is-visible {
  z-index: 90;
  opacity: 1;
  pointer-events: auto;
}

.l-report__mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* UI 稿为纯背景，不做黑色蒙层 */
  background: transparent;
}

.l-report__stage {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.6);
}

.l-report__stage::before {
  content: '';
  position: absolute;
  right: -40%;
  bottom: -40%;
  left: 50%;
  top: 45%;
  width: 1600px;
  height: 1600px;
  transform: translate(-50%, -50%);
  background:
    repeating-conic-gradient(
      from -12deg,
      rgba(125, 235, 255, 0.0) 0deg,
      rgba(125, 235, 255, 0.0) 7deg,
      rgba(125, 235, 255, 0.12) 8deg,
      rgba(125, 235, 255, 0.0) 14deg
    );
  mix-blend-mode: soft-light;
  opacity: 0.75;
  filter: blur(0.5px);
  pointer-events: none;
}

.l-report__light {
  position: absolute;
  top: -24px;
  width: 620px;
  height: 620px;
  background: url('./images/light.png') center / contain no-repeat;
  opacity: 0.9;
  filter: saturate(1.05);
  animation: l-report-rotate 3.2s linear infinite;
}

@keyframes l-report-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.l-report__panel {
  position: relative;
  width: min(880px, 92vw);
  box-sizing: border-box;
}

.l-report__badge-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  width: 520px;
  margin: 0 auto;
}

.l-report__badge {
  display: block;
  width: 100%;
  height: auto;
}

.l-report__stars {
  position: absolute;
  left: 50%;
  top: 148px;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
}

.l-report__star {
  width: 48px;
  height: 48px;
  background: url('./images/star.png') center / contain no-repeat;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.25));
}

.l-report__star.is-active {
  background-image: url('./images/star-active.png');
}

.l-report__level-pill {
  position: absolute;
  left: 50%;
  top: 216px;
  transform: translateX(-50%);
  padding: 7px 18px;
  border-radius: 18px;
  background: #6a2f1d;
  color: #ffd599;
  border: 3px solid #ffffff;
  box-shadow: inset 0 0 4px rgba(25, 3, 51, 0.34);
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.l-report__titles {
  position: relative;
  z-index: 1;
  margin-bottom: 6px;
  display: grid;
  grid-template-columns: 0.8fr repeat(var(--column-count, 2), 1.2fr) 0.8fr;
  align-items: flex-end;
  padding: 0 22px 8px;
  color: #6b3c1e;
}

.l-report__title-cell {
  text-align: center;
}

.l-report__title-cell:first-child,
.l-report__title-cell:last-child {
  text-align: left;
}

.l-report__title-line {
  font-size: 18px;
  line-height: 1.3;
  font-weight: 700;
  white-space: nowrap;
}

.l-report__table {
  position: relative;
  top: -80px;
  padding: 16px;
  border-radius: 52px;
  background: #916543;
  box-shadow: inset 0 -2px 6px rgba(77, 1, 1, 0.58);
}

.l-report__content {
  position: relative;
  max-height: 260px;
  padding: 16px;
  background: rgba(245, 244, 233, 1);
  border-radius: 40px;
  box-shadow: 0 2px 4px rgba(59, 9, 2, 0.34);
  overflow: auto;
}
.l-report__content::-webkit-scrollbar {
  display: none;
}

.l-report__row {
  position: relative;
  display: grid;
  grid-template-columns: 0.8fr repeat(var(--column-count, 2), 1.2fr) 0.8fr;
  align-items: center;
  gap: 10px;
  padding: 18px 22px;
  background: rgba(255, 255, 255, 0.88);
  border-radius: 34px;
  box-shadow: none;
}

.l-report__row + .l-report__row {
  margin-top: 12px;
}

.l-report__cell {
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
  white-space: nowrap;
}

.l-report__cell--name {
  color: #916543;
}

.l-report__cell--value {
  text-align: center;
  color: #52ad11;
}

.l-report__cell--coin {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.l-report__coin-icon {
  width: 28px;
  height: 28px;
  background: url('./images/coin.png') center / contain no-repeat;
  flex: 0 0 auto;
}

.l-report__coin-text {
  color: #ff8d1a;
  font-weight: 800;
}

.l-report__actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: -120px;
}

.l-report__btn {
  width: 245px;
  height: 105px;
  border: 0;
  padding: 0;
  padding-bottom: 16px;
  background: transparent center / 100% 100% no-repeat;
  font-size: 22px;
  letter-spacing: 1px;
  font-weight: 800;
  cursor: pointer;
  user-select: none;
  filter: drop-shadow(0 16px 26px rgba(0, 0, 0, 0.22));
}

.l-report__btn.is-yellow {
  background-image: url('./images/button-bg-yellow.png');
  color: #ea741b;
  text-shadow: 1px 3px 6px rgba(252, 210, 82, 0.75);
}

.l-report__btn.is-green {
  background-image: url('./images/button-bg-green.png');
  color: #448c0d;
  text-shadow: 1px 3px 6px rgba(158, 215, 118, 0.75);
}

@media (max-width: 420px) {
  .l-report__panel {
    padding: 132px 14px 18px;
  }
  .l-report__star {
    width: 40px;
    height: 40px;
  }
  .l-report__row {
    padding: 14px 14px;
    grid-template-columns: 1.2fr 0.85fr 0.85fr 0.8fr;
  }
  .l-report__cell {
    font-size: 16px;
  }
  .l-report__btn {
    width: 210px;
    height: 90px;
    font-size: 20px;
  }
}
</style>
